import { CustomerLight } from "src/app/backend/models/customer/customer";
import { VatNatureType } from "../vat-nature-type";
import {
  QuoteItemType,
  QuoteItemUnit
} from "src/app/backend/models/quote/quote.item";
import { InvoiceType } from "src/app/backend/models/invoice/invoice";
import { CartItemUnit } from "src/app/backend/models/cart";
import { InvoiceItemUnit } from "src/app/backend/models/invoice/invoice.item";
import { GoodUnit } from "src/app/backend/models/warehouse/good";

export enum BookItemType {
  MEDICAL_SERVICE = "medical-service",
  DRUG_ASSIGNMENT = "drug-assignment",
  PARAPHARMACEUTICAL = "parapharmaceutical",
  PRODUCT_SALE = "product-sale",
  ADVANCE_PAYMENT = "advance-payment"
}

export enum BookItemUnit {
  PIECE = "piece",
  PACKAGE = "package"
}

export interface BookItem {
  id: string;
  rateTableItemId: string; // id del rateTableItem
  type: BookItemType;
  number: string;
  name: string;
  description?: string;
  quantity: number;
  unitPrice: number;
  discount?: number;
  vat: number;
  vatNature?: VatNatureType;

  patientId?: string;

  rateable: number; // Imponibile di riga (al netto della cassa)
  vatTaxAmount: number; // Ammontare della tassa IVA
  adjustment?: number; // Aggiustamento sul totale
  adjustedTotal: number; // Totale corretto (Totale da pagare)

  createdAt: string;
  createdBy: {
    id: string;
    name: string;
  };

  executedBy: Array<{
    id: string;
    name: string;
    percentage: number;
  }>;

  executedAt?: string;

  updatedAt?: string;

  rateTable: {
    id: string;
    name: string;
  };

  ticket?: {
    id: string;
    number: string;
  };

  usedIn?: Array<{
    id: string;
    amount: number;
    number: string;
  }>;

  invoice?: {
    id: string;
    type: InvoiceType;
    itemId?: string;
    number?: string;
    emittedAt?: string;
    emittedBy?: {
      id: string;
      name: string;
    };
    draft?: boolean;
  };

  origin?: {
    id: string;
    number: string;
    type:
      | "quote"
      | "work-order"
      | "health-record"
      | "vaccine"
      | "recovery"
      | "prescription";
  };

  remainingAmount?: number;

  hasEnpav: boolean;

  unit: BookItemUnit;
}

export interface BookItemCreate {
  rateTableItemId: string; // id del rateTableItem
  type: BookItemType;
  number: string;
  name: string;
  description?: string;

  quantity: number;
  maxQuantity?: number;

  unitPrice: number;
  maxUnitPrice?: number;

  discount?: number;
  vat: number;
  vatNature?: VatNatureType;

  rateable?: number; // Imponibile di riga (al netto della cassa)

  adjustment?: number;

  updatedAt?: string;

  rateTable?: {
    id: string;
    name: string;
  };

  ticket?: {
    id: string;
    number: string;
    customer?: Partial<CustomerLight>;
  };

  invoiceId?: string;

  origin?: {
    id: string;
    number: string;
    type:
      | "quote"
      | "work-order"
      | "health-record"
      | "vaccine"
      | "recovery"
      | "prescription";
  };

  vatTaxAmount?: number;
  taxedTotal?: number;
  adjustedTotal?: number;

  hasEnpav?: boolean;
  bookItemId?: string;

  executedBy: Array<{ id: string; name: string; percentage: number }>;
  executedAt?: string;

  physiciansPercentage: number;

  unit?: BookItemUnit;
}

export function quoteItemTypeToBookItemType(
  quoteItemType: QuoteItemType
): BookItemType {
  switch (quoteItemType) {
    case QuoteItemType.MEDICAL_SERVICE:
      return BookItemType.MEDICAL_SERVICE;
    case QuoteItemType.DRUG_ASSIGNMENT:
      return BookItemType.DRUG_ASSIGNMENT;
    case QuoteItemType.PRODUCT_SALE:
      return BookItemType.PRODUCT_SALE;
    case QuoteItemType.PARAPHARMACEUTICAL:
      return BookItemType.PARAPHARMACEUTICAL;
  }
}

export function bookItemUnitFromCartItemUnit(
  cartItemUnit: CartItemUnit | undefined
): BookItemUnit | undefined {
  switch (cartItemUnit) {
    case undefined: {
      return undefined;
    }
    case CartItemUnit.PIECE:
      return BookItemUnit.PIECE;
    case CartItemUnit.PACKAGE:
      return BookItemUnit.PACKAGE;
  }
}

export function bookItemUnitToCartItemUnit(
  bookItemUnit: BookItemUnit | undefined
): CartItemUnit | undefined {
  switch (bookItemUnit) {
    case undefined: {
      return undefined;
    }
    case BookItemUnit.PIECE:
      return CartItemUnit.PIECE;
    case BookItemUnit.PACKAGE:
      return CartItemUnit.PACKAGE;
  }
}

export function bookItemUnitFromQuoteItemUnit(
  quoteItemUnit: QuoteItemUnit | undefined
): BookItemUnit | undefined {
  switch (quoteItemUnit) {
    case undefined: {
      return undefined;
    }
    case QuoteItemUnit.PACKAGE:
      return BookItemUnit.PACKAGE;
    case QuoteItemUnit.PIECE:
      return BookItemUnit.PIECE;
  }
}

export function bookItemUnitFromGoodUnit(goodUnit: GoodUnit): BookItemUnit {
  switch (goodUnit) {
    case GoodUnit.PACKAGE:
      return BookItemUnit.PACKAGE;
    case GoodUnit.PIECE:
      return BookItemUnit.PIECE;
  }
}

export function bookItemUnitToQuoteItemUnit(
  bookItemUnit: BookItemUnit | undefined
): QuoteItemUnit | undefined {
  switch (bookItemUnit) {
    case undefined: {
      return undefined;
    }
    case BookItemUnit.PACKAGE:
      return QuoteItemUnit.PACKAGE;
    case BookItemUnit.PIECE:
      return QuoteItemUnit.PIECE;
  }
}

export function bookItemUnitToInvoiceItemUnit(
  bookItemUnit: BookItemUnit | undefined
): InvoiceItemUnit | undefined {
  switch (bookItemUnit) {
    case undefined: {
      return undefined;
    }
    case BookItemUnit.PACKAGE:
      return InvoiceItemUnit.PACKAGE;
    case BookItemUnit.PIECE:
      return InvoiceItemUnit.PIECE;
  }
}
